const getSliderMedia = ({ images, videos, isPsxVdp, showSpin, vhrTile, fallbackImg }) => {
    const media = [];

    // If 360 spin exists, add it first and use first image as its src
    // If listing has Spin360 but no images, use fallback placeholder as its src
    if (showSpin) {
        media.push({
            type: 'spin',
            data: (images.length > 0 && images[0]?.src) ? images[0] : { src: fallbackImg },
            index: 0,
        });
    }

    if (isPsxVdp) {
        // Add all images first
        images.forEach((image, imageIndex) => {
            media.push({
                type: 'image',
                data: image,
                imageIndex,
                index: media.length,
            });
        });

        // Add all videos except psxHowItWorks
        videos.filter((v) => v.videoId !== 'psxHowItWorks').forEach((video, videoIndex) => {
            media.push({
                type: 'video',
                data: video,
                videoIndex,
                index: media.length,
            });
        });

        // Add video with videoId = 'psxHowItWorks' last
        videos.filter((v) => v.videoId === 'psxHowItWorks').forEach((video, videoIndex) => {
            media.push({
                type: 'video',
                data: video,
                videoIndex,
                index: media.length,
            });
        });
    } else {
        // Add videos next (after spin or as first if no spin)
        videos.forEach((video, videoIndex) => {
            media.push({
                type: 'video',
                data: video,
                videoIndex,
                index: media.length,
            });
        });

        // Add all images
        images.forEach((image, imageIndex) => {
            media.push({
                type: 'image',
                data: image,
                imageIndex,
                index: media.length,
            });
        });
    }

    // Add VHR tile if available
    if (vhrTile) {
        media.push({
            type: 'vhr',
            isVhr: true,
            index: media.length,
        });
    }

    // Add placeholder if only one media item (360/video/image)
    if (media.length === 1) {
        media.push({
            type: 'placeholder',
            isPlaceholder: true,
            index: media.length,
        });
    }

    // Add request button
    media.push({
        type: 'requestButton',
        isRequestButton: true,
        index: media.length,
    });

    return media;
};

export default getSliderMedia;
